export default theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.border}`,
    backgroundColor: theme.palette.common.white,
    display: "flex",
    alignItems: "center",
    height: "80px",
    zIndex: theme.zIndex.appBar
  },
  toolbar: {
    height: "80px",
    width: "100%",
    backgroundColor: theme.palette.background.mainDark
  },

  logoWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "63px",
    flexShrink: 0
  },
  logoLink: {
    fontSize: 0,
    textDecoration: "none"
  },
  logoImage: {
    cursor: "pointer",
    width: "150px",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  nameText: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    maxWidth: "170px",
    color: theme.palette.common.white,
    textDecoration: "none"
  },
  menuButton: {
    marginLeft: "-4px"
  },

  icon: {
    color: theme.palette.text.darkBackground
  },
  lastIcon: {
    marginRight: theme.spacing(4),
    color: theme.palette.text.darkBackground
  },
  userContainer: {
    display: "flex",
    marginLeft: "auto"
  },
  navbarAvatar: {
    marginRight: theme.spacing(1),
    background: theme.palette.background.mainLight
  },
  navbarUsername: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.darkBackground,
    background: theme.palette.background.mainDark,
    textTransform: "none",
    "&:hover": {
      background: theme.palette.background.mainLight
    }
  },
  navbarUsernameDropdown: {
    marginRight: theme.spacing(1)
  },
  dropdownMenu: {
    backgroundColor: theme.palette.background.mainDark,
    width: "160px",
    paddingTop: 0,
    paddingBottom: 0
  },
  dropdownMenuList: {
    paddingBottom: 0
  },

  dropdownMenuLink: {
    textDecoration: "none"
  },
  dropdownMenuItem: {
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    height: "40px",
    color: theme.palette.text.darkBackground,
    display: "flex",
    flexDirection: "column"
  },
  iconAndText: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "100%",
    justifyContent: "flex-start",
    alignItems: "center",
    paddingLeft: theme.spacing(2)
  },
  dropdownMenuText: {
    paddingLeft: theme.spacing(1.5),
    color: theme.palette.text.darkBackground,
    textTransform: "uppercase",
    fontSize: "12px",
    lineHeight: "12px",
    textDecoration: "none"
  },

  hideShowBoxContainer: {
    display: "flex",
    height: "100%"
  },
  dropdownIcon: {
    height: "18px",
    width: "18px"
  },
  activeListItem: {
    textDecoration: "none",
    fontSize: "30px"
  },
  divider: {
    background: theme.palette.background.mainLight,
    width: "128px"
  }
});
